<template>
<div class="no_top_margin">
    <div id="explain">
        <div class="icon">
            <i class="fas fa-comments-dollar"></i>
        </div>
        <p>אתם מוזמנים לשתף, לחקור
ולהתחיל שיחה עם אנשי מדיה
ואומנים בקהילה</p>
<router-link to="/inbox" class="btn">למעבר לתיבת ההודעות</router-link>
    </div>
    <div id="users">
        <div class="filter">
            <div>
                <md-input v-model="filter.q" label="חיפוש חופשי לפי שם" @input="init_search"></md-input>
            </div>
             <div>
                 <div class="switch">
                <div class="switch_btn" @click="filter.type = 'artist';init_search()" :class="(filter.type == 'artist' ? 'active' : '')">אמנים</div>
                <div class="switch_btn" @click="filter.type = 'media';init_search()" :class="(filter.type == 'media' ? 'active' : '')">אנשי מדיה</div>
               </div>
            </div>
            <div>
                <wzselect v-model="filter.genre" @change="load_results" :settings="{label: 'סוג נקודת השידור'}" :options="$store.genres.map(row => { return { key: row.id, val: row.name } })" />
            </div>
      
            <div class="clr"></div>
        </div>
        <div class="users">
            <div class="col-md-4" v-for="user in items" :key="user.id">
                <router-link :to="'/inbox/'+user.id">
                 <div class="user" >
                     <div class="col-md-4"><div :class="(user.pic_parsed  ? 'pic': 'pic no-user') " :style="'background-image:url('+user.pic_parsed +')'"></div></div>
                     <div class="col-md-8">
                         <p v-text="user.display_name"></p>
                         <p v-text="(user.type == 'artist' ? 'אמן'  : 'איש מדיה')"></p>
                         <h6></h6>
                     </div>
                 </div>
                 </router-link>
            </div>
            <div class="clr"></div>
        </div>
    </div>
    </div>
</template>
<style lang="scss" scoped>
#explain{width: 20%;display: inline-block;background: #4c4c4c;height: 100vh;float: right;padding-top: 300px;max-height:calc(100vh - 98px); ;overflow: auto}
#explain{
    .btn{text-align: center;margin: 10px auto;display: block;width: 70%;}
    .icon{font-size: 90px; text-align: center; color: #fff;margin-bottom: 20px;}
    p{color: #fff;font-size: 20px;text-align: center;width: 80%;margin: 0 auto;}
}
#users{
    &{background: #f0f0f0;;width: 80%;display: inline-block;max-height:calc(100vh - 98px); ;overflow-y: auto}
    .filter{padding: 10px 20px; display: flex; gap:15px;}
    .switch{height: 40px;padding: 4px 13px 10px 7px;;border-radius: 34.8px;border: solid 0.8px #333333;width: 200px;}
    .switch{
        .switch_btn{width: 50%;height: 29px;;padding: 7px;border-radius: 12.6px;background-color: transparent;color: #333333;display: inline-block;text-align: center;cursor: pointer;line-height: 14px;}
        .active{background: #ff005e;color: #fff;}
    }
    .users{
        .user{color: #000;}
        .col-md-4{margin-bottom: 20px;}
        .col-md-4:nth-child(3n+1){clear: both;}
            .pic{height: 60px;width: 60px;border-radius: 100%;background-size: contain;margin: 0 auto;}
        }
}
</style>
<script>

export default {
    components: { },
  data(){
    return {
         filter: {
          page: 0,
            q: '',
            genre: '',
            type: 'artist'
        }, 
        items: [],
        on_loading: false,
        searchTimer: null,
        end_results: false,
        xhr: false,
        }
    },
    methods: {
    onDrop(e) {
      this.dropped.push(e.data);
    },
    load_results(){
      
      if (this.xhr) this.xhr.cancel();
      

    //  alert(this.filter.page)
        this.filter.page++;

        if (this.filter.page == 1) 
        {
          this.items = [];
          this.end_results = false;
        }

        if (this.end_results) return;

        this.on_loading = true;
        this.xhr = this.api({ action: 'users/results', data: this.filter, }, (data) => {
          if (data.data.items.length == 0) this.end_results = true;
          if (this.filter.page == 1) this.items = data.data.items; 
          else this.items.push(...data.data.items); 
                    
          this.on_loading = false;
        });

    },
    init_search()
    {
        clearTimeout(this.searchTimer);
        var self = this;
        this.searchTimer = setTimeout(function(){
          self.filter.page = 0;
          self.load_results();
        }, 200);
        
    }

  },
   mounted(){
        
        this.load_results();
        let scrollEl = document.getElementById('users');

        scrollEl.onscroll = () => {
        if  (!this.on_loading && document.documentElement.scrollTop + 400 >= (document.body.scrollHeight - window.innerHeight ))
        {
            this.load_results();
        }
        };
    }
}
</script>